<template>
	<li :class="{ 'drag-target': isDragTarget }">
		<div class="line">
			<button
				v-if="item.children && item.children.length"
				class="button"
				@click="isOpen = !isOpen"
			>
				<i
					:class="
						isOpen ? 'tan-icon-arrow-down' : 'tan-icon-arrow-right'
					"
				/>
			</button>
			<div v-else class="expand-button-placeholder" />
			<b-form-checkbox
				:disabled="Boolean(item.temp)"
				:checked="checked"
				class="checkbox"
				@change="onChange"
			>
				<i :class="`tan-icon-${icons[item.type]}`" />
				<span
					v-b-tooltip.hover
					class="name"
					:title="item.name"
					@click.prevent
					@dblclick="onDblclick"
					@mousedown.prevent
				>{{ item.name }}</span>
			</b-form-checkbox>
			<span class="zoom-button" />
			<b-dropdown
				v-if="
					item.data &&
						item.data[0].data.properties &&
						item.data[0].data.properties.length > 1
				"
				id="dropdown-dropright-2"
				dropright
				variant="link"
				toggle-class="text-decoration-none"
				size="sm"
				no-caret
				menu-class="itemMenu text-white"
			>
				<template #button-content>
					<b-icon-filter />
				</template>
				<b-dropdown-item
					v-for="property of item.data[0].data.propertyNames"
					:key="property"
					@click="setProperty(item, property)"
				>
					<button class="button text-white text-center w-100">
						{{ property }}
					</button>
				</b-dropdown-item>
			</b-dropdown>
			<b-dropdown
				id="dropdown-dropright"
				:disabled="Boolean(item.temp)"
				dropright
				variant="link"
				toggle-class="text-decoration-none"
				no-caret
				size="sm"
				menu-class="itemMenu text-white ml-5"
			>
				<template #button-content>
					<b-icon-three-dots />
				</template>
				<b-dropdown-item @click="onButtonClick">
					<button class="button text-white">
						<b-icon icon="search" />
						Zoom
					</button>
				</b-dropdown-item>
				<b-dropdown-item @click="onPencilClick">
					<button class="button text-white">
						<b-icon icon="eye" />
						Edit Appearance
					</button>
				</b-dropdown-item>
				<b-dropdown-item @click="onEditPropertiesClick">
					<button class="button text-white">
						<b-icon icon="pencil" />
						Edit Properties
					</button>
				</b-dropdown-item>
				<b-dropdown-item @click="onDeleteClick">
					<button class="button text-white">
						<b-icon icon="x" />
						Delete
					</button>
				</b-dropdown-item>
			</b-dropdown>
		</div>
		<b-collapse v-model="isOpen" style="max-height:200px; overflow-y:auto">
			<ul
				v-if="item.children && item.children.length"
				class="nested-list"
			>
				<tree-item
					v-for="(child, childIndex) in item.children"
					:key="child.id"
					:item="child"
					:index="childIndex"
					:checked="childrenChecked"
					@change="passChange"
					@dblclick="passDblclick"
					@buttonclick="passButtonClick"
					@pencilclick="passPencilClick"
					@deleteclick="passDeleteClick"
				/>
			</ul>
		</b-collapse>
	</li>
</template>

<script>
	import ElementManagerVue from './Project/Tool/ElementManager.vue';

	export default {
		name: 'TreeItem',
		props: {
			checked: {
				required: true,
				type: Boolean,
			},
			index: {
				required: true,
				type: Number,
			},
			item: {
				required: true,
				type: Object,
			},
		},
		data() {
			return {
				childrenChecked: this.checked,
				icons: {
					layer: 'group',
					luminaire: 'sunlight',
					microcell: 'create-new',
					parcel: 'procurement',
					pole: 'subtract',
					streetlight: 'baseline',
				},
				incomingDraggedItem: null,
				isDragTarget: false,
				isOpen: false,
			};
		},
		methods: {
			onEditPropertiesClick() {
				this.$czm('emitEntityClicked', this.item.id);
			},
			onChange(checked) {
				this.childrenChecked = checked;
				this.$emit('change', {
					checked,
					...this.item,
				});
			},
			onDblclick() {
				this.$emit('dblclick', this.item.id);
			},
			onButtonClick() {
				this.$emit('buttonclick', this.item.id);
			},
			onPencilClick() {
				this.$emit('pencilclick', this.item);
			},
			onDeleteClick() {
				this.$el.hidden = true;
				this.$emit('deleteclick', this.item.id);
			},
			passChange(data) {
				this.$emit('change', data);
			},
			passDblclick(data) {
				this.$emit('dblclick', data);
			},
			passButtonClick(id) {
				this.$emit('buttonclick', id);
			},
			passPencilClick(id) {
				this.$emit('pencilclick', id);
			},
			passDeleteClick(id) {
				this.$emit('deleteclick', id);
			},
			async setProperty(data, filterProperty) {
				await this.$czm('updateEntityData', data.id, {
					data: { filterProperty },
				});
				this.$czm('getTreeMenu');
			},
		},
	};
</script>

<style scoped>
	.drag-target {
		border-top: 2px black solid;
	}

	.line {
		display: flex;
		align-items: center;
	}

	.button {
		background: transparent;
		border: none;
	}

	.expand-button-placeholder {
		flex: 0 0 30.4px;
	}

	.checkbox {
		min-width: 0;
	}

	.name {
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.zoom-button {
		margin-left: auto;
	}

	.nested-list {
		list-style: none;
	}
</style>

<style lang="scss">
	.dropdown-menu {
		max-height: 500px;
		overflow-y: auto;
		padding: 10px;
	}
	.itemMenu {
		background-color: rgba(42, 47, 65, 0.87) !important;
		color: rgb(249, 249, 253);
		min-width: 5px !important;

		.dropdown-item {
			padding: 0px !important;
			text-align: justify;
		}
	}

	.custom-control-label {
		display: flex;
		white-space: nowrap;
	}
</style>
